// frontend/src/components/pages/BoxLineInputPage.js
import { useEffect, useState, useRef, useCallback } from 'react';
import BoxLinesTable from '../tables/BoxLinesTable';
import ManualBoxLinesTable from '../tables/ManualBoxLinesTable';
import ManualBoxLineForm from '../common/ManualBoxLineForm';
import useManualControl from '../../hooks/useManualControl';
import { sessionDateForDays } from '../../utils/manualBoxLine';

export default function BoxLineInputPage() {
  const [sessionDate, setSessionDate] = useState(() => sessionDateForDays(0));
  const [refreshKey, setRefreshKey] = useState(0);
  const tableRef = useRef();
  const initialized = useRef(false);
  const { control, error, refresh } = useManualControl();
  const today = sessionDateForDays(-1);
  const daysDelta =
    Math.round((Date.parse(today) - Date.parse(sessionDate)) / 86400000) - 1;
  const weekday = new Intl.DateTimeFormat('ko-KR', {
    timeZone: 'Asia/Seoul',
    weekday: 'short',
  }).format(new Date(`${sessionDate}T00:00:00+09:00`));
  useEffect(() => {
    if (control && !initialized.current) {
      initialized.current = true;
      setSessionDate(control.session_date);
    }
  }, [control]);
  const moveDate = (amount) => {
    const date = new Date(`${sessionDate}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() + amount);
    const next = date.toISOString().slice(0, 10);
    setSessionDate(next > today ? today : next);
  };
  const handleSuccess = useCallback(() => {
    tableRef.current?.reload();
    setRefreshKey((value) => value + 1);
  }, []);
  return (
    <div className='w-full text-center'>
      <p className='mt-4' role='status'>
        {error ||
          (control
            ? `${control.mode === 'MANUAL_MODE' ? '수동' : '자동'} 전략 생성 모드${control.can_manage ? '' : ' · 조회 전용'}`
            : '거래 모드 확인 중…')}
      </p>
      <div className='text-[2rem]'>
        <button
          type='button'
          onClick={() => moveDate(-1)}
          className='mr-8 mt-8 text-[1.5rem]'
        >
          ◀
        </button>
        {sessionDate} ({weekday}) 데이터
        <button
          type='button'
          className='ml-4 text-base border rounded px-2'
          onClick={async () => {
            const data = await refresh();
            if (data) {
              setSessionDate(data.session_date);
              handleSuccess();
            }
          }}
        >
          현재 세션
        </button>
        <button
          type='button'
          onClick={() => moveDate(1)}
          className='ml-8 text-[1.5rem]'
        >
          ▶
        </button>
      </div>
      <div className='w-full max-w-[1600px] mx-auto px-4'>
        <BoxLinesTable
          daysDelta={daysDelta}
          control={control}
          refreshKey={refreshKey}
          onStrategyChanged={handleSuccess}
        />
        <ManualBoxLineForm
          sessionDate={sessionDate}
          control={control}
          onSuccess={handleSuccess}
        />
        <ManualBoxLinesTable
          ref={tableRef}
          daysDelta={daysDelta}
          control={control}
          onStrategyChanged={handleSuccess}
        />
      </div>
    </div>
  );
}
